import { style } from "@vanilla-extract/css";

import type { ColorName } from "../types/ColorName";
import { theme } from "./theme.css";

export const colors = Object.fromEntries(
  Object.entries(theme.colors).map(([name, color]) => [name, style({ color })]),
) as Record<ColorName, string>;

export const backgroundColors = Object.fromEntries(
  Object.entries(theme.colors).map(([name, color]) => [
    name,
    style({ backgroundColor: color }),
  ]),
) as Record<ColorName, string>;
